import { useEffect } from 'react';

/**
 * Attaches an IntersectionObserver to all [data-reveal] elements in the document.
 * When they scroll into view, adds `.is-visible` which triggers CSS fade+slide.
 * Call once at app root.
 */
const useScrollReveal = () => {
  // Mount-once effect: attaches global IntersectionObserver + MutationObserver
  // to all [data-reveal] elements. No React state involved.
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    const attach = () => {
      document.querySelectorAll('.reveal-on-scroll:not(.is-visible)').forEach((el) => {
        observer.observe(el);
      });
    };

    attach();
    // Re-attach on DOM mutations
    const mutationObs = new MutationObserver(() => attach());
    mutationObs.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutationObs.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useScrollReveal;
